/**
 * Airport summary model containing abbreviated information about an airport
 */
var AirportSummary = /** @class */ (function () {
    function AirportSummary() {
    }
    Object.defineProperty(AirportSummary.prototype, "identifier", {
        /**
         * Gets the identifier that should be displayed for this airport. This will either be the ICAO identifier if
         * available, or the FAA identifier otherwise.
         */
        get: function () {
            return this.icaoId || this.faaId || '';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses an airport as returned by the API into an instance of the Airport class
     */
    AirportSummary.parse = function (data) {
        return Object.assign(new AirportSummary(), {
            airportId: data.airportId,
            sourceId: data.sourceId,
            icaoId: data.icaoId,
            faaId: data.faaId,
            name: data.name
        });
    };
    return AirportSummary;
}());
export { AirportSummary };
